import { forwardRef } from 'react';

import { IconProps } from '.';

export const ActivityIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M5.49999 5.68005C5.49999 6.30413 4.99407 6.81005 4.36999 6.81005C3.74591 6.81005 3.23999 6.30413 3.23999 5.68005C3.23999 5.05597 3.74591 4.55005 4.36999 4.55005C4.99407 4.55005 5.49999 5.05597 5.49999 5.68005Z"
        fill="currentColor"
      />
      <path
        d="M7.75 9.43994H14.25C14.4489 9.43994 14.6397 9.36092 14.7803 9.22027C14.921 9.07962 15 8.88885 15 8.68994C15 8.49103 14.921 8.30026 14.7803 8.15961C14.6397 8.01896 14.4489 7.93994 14.25 7.93994H7.75C7.55109 7.93994 7.36032 8.01896 7.21967 8.15961C7.07902 8.30026 7 8.49103 7 8.68994C7 8.88885 7.07902 9.07962 7.21967 9.22027C7.36032 9.36092 7.55109 9.43994 7.75 9.43994Z"
        fill="currentColor"
      />
      <path
        d="M16 6.42993H7.75C7.55109 6.42993 7.36032 6.35091 7.21967 6.21026C7.07902 6.06961 7 5.87884 7 5.67993C7 5.48102 7.07902 5.29025 7.21967 5.1496C7.36032 5.00895 7.55109 4.92993 7.75 4.92993H16C16.1989 4.92993 16.3897 5.00895 16.5303 5.1496C16.671 5.29025 16.75 5.48102 16.75 5.67993C16.75 5.87884 16.671 6.06961 16.5303 6.21026C16.3897 6.35091 16.1989 6.42993 16 6.42993Z"
        fill="currentColor"
      />
      <path
        d="M5.49999 11.6901C5.49999 12.3141 4.99407 12.8201 4.36999 12.8201C3.74591 12.8201 3.23999 12.3141 3.23999 11.6901C3.23999 11.066 3.74591 10.5601 4.36999 10.5601C4.99407 10.5601 5.49999 11.066 5.49999 11.6901Z"
        fill="currentColor"
      />
      <path
        d="M14.25 15.45H7.75C7.55109 15.45 7.36032 15.3709 7.21967 15.2303C7.07902 15.0896 7 14.8989 7 14.7C7 14.501 7.07902 14.3103 7.21967 14.1696C7.36032 14.029 7.55109 13.95 7.75 13.95H14.25C14.4489 13.95 14.6397 14.029 14.7803 14.1696C14.921 14.3103 15 14.501 15 14.7C15 14.8989 14.921 15.0896 14.7803 15.2303C14.6397 15.3709 14.4489 15.45 14.25 15.45Z"
        fill="currentColor"
      />
      <path
        d="M7.75 12.4399H16C16.1989 12.4399 16.3897 12.3609 16.5303 12.2203C16.671 12.0796 16.75 11.8889 16.75 11.6899C16.75 11.491 16.671 11.3003 16.5303 11.1596C16.3897 11.019 16.1989 10.9399 16 10.9399H7.75C7.55109 10.9399 7.36032 11.019 7.21967 11.1596C7.07902 11.3003 7 11.491 7 11.6899C7 11.8889 7.07902 12.0796 7.21967 12.2203C7.36032 12.3609 7.55109 12.4399 7.75 12.4399Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ActivityIcon;
